const PartnerBillingInfoResources = {
    labelBillingType: 'Billing Type',
    titleWithdrawalFromBankingInfo: 'Withdrawal from banking info',
    formPartnerBillingInfo: 'partnerBillingInfoForm',
    fieldPartnerBillingTypeID: 'partnerBillingTypeID',
    bankAccountModelName: 'bankAccount'
};

export default PartnerBillingInfoResources;
